<template>
  <div class="m-b-sm">
    <span class="m-t-md m-l-md load-icon" @click="reload">
      <img v-if="$store.getters.isMH" src="@/../static/svg/load.svg" class="is-inline-block is-large icon">
      <img v-else src="@/../static/kfit/replay.svg" class="is-inline-block is-large icon">
    </span>
    <div class="has-text-centered m-t-md">
      <router-link :to="{ name: 'Home' }">
        <img src="@/../static/svg/win.svg" class="is-inline-block is-xlarge icon" />
      </router-link>
    </div>
    <span class="m-t-md m-r-md menu-icon" @click="showMenu">
      <img v-if="$store.getters.isMH" src="@/../static/svg/menu.svg" class="is-inline-block is-large icon">
      <img v-else src="@/../static/kfit/menu.svg" class="is-inline-block is-large icon">
    </span>
    <Menu ref="menu" :show="false" />
    <div class="has-text-centered m-t-md">
      <p class="is-size-3">{{ $t('SUPER WORKOUT!') }}</p>
      <p class="is-size-4 has-text-grey-light">{{ $t('You made 1 Day') }}</p>
      <p class="is-size-3">{{ currentTraining.time }} min</p>
      <p class="is-size-4 m-t-xl">{{ $t('With protein for training success') }}</p>
      <router-link :to="{ name: 'EatingPlan' }" class="button has-background-primary has-text-white is-size-4 is-rounded p-l-xl p-r-xl">
        {{ 'Eating plan' | translate }}
      </router-link>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/Menu'

export default {
  name: 'TrainingEnd',
  data () {
    let currentTraining = {
      time: '15:40'
    }
    if (this.$store.getters.getCurrentTrainingName) {
      currentTraining = this.$store.getters.getTrainingByName(this.$store.getters.getCurrentTrainingName)
    }

    return {
      currentTraining
    }
  },
  methods: {
    reload (){
      this.$router.push({ name: 'Training' })
    },
    showMenu() {
      this.$refs.menu.showMe()
    }
  },
  components: {
    Menu
  }
}
</script>

<style>
.menu-icon {
  opacity:0.5;
  position:absolute;
  top:1rem;
  right:0.5rem;
}
.load-icon {
  opacity:0.5;
  position:absolute;
  top:1rem;
  left:0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/TrainingEnd.vue